export function logStep(message: string): void {
  console.log(`[go-offline] ${message}`);
}

export function logResult(filePath: string, status: "created" | "skipped"): void {
  console.log(`[go-offline] ${status === "created" ? "created" : "skipped"} ${filePath}`);
}
